// @ts-nocheck
import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Input,
  TextField,
  Typography,
  FormControlLabel,
  Checkbox,
  FormControl,
  Select,
  MenuItem,
  SelectChangeEvent,
} from "@mui/material";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import CancelIcon from "@mui/icons-material/Cancel";
import { useNavigate, useParams } from "react-router-dom";
import { UploadMedia } from "../../utils/uploadMedia";
import { errorToast, successToast } from "../../helpers/toast";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Autocomplete } from "@react-google-maps/api";
import {
  useAddDiscountMutation,
  useLazyGetDiscountByIdQuery,
  useUpdateDiscountMutation,
} from "../../services/discount";
import { isNumber } from "../../utils/validation";
import { useLazyAllCategoryQuery } from "../../services/main";
import {
  useAddCouponMutation,
  useLazyGetCouponByIdQuery,
  useUpdateCouponMutation,
} from "../../services/coupon";
import moment from "moment";
import useTranslation from "../../hooks/Translation";

const AddDiscount = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const t = useTranslation();
  const [profilePicture, setProfilePicture] = useState("");
  const [imageId, setImageId] = useState(0);
  const [addDiscount] = useAddCouponMutation();
  const [getCategory] = useLazyAllCategoryQuery();
  const [getDiscountDetails] = useLazyGetCouponByIdQuery();
  const [updateBanner] = useUpdateCouponMutation();

  const [imageError, setImageError] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedBannerType, setSelectedBannerType] = useState("");
  const [categoryData, setCategoryData] = useState([]);
  const [discountData, setDiscountData] = useState<any>();
  const [error, setError] = useState(false);

  const handlePricingChange = (event: SelectChangeEvent) => {
    setSelectedCategory(event.target.value as string);
  };

  const handleChangeType = (event: SelectChangeEvent) => {
    setSelectedBannerType(event.target.value as string);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      discount_name_en: discountData?.discount_name_en || "",
      discount_name_ar: discountData?.discount_name_ar || "",
      discount_name_rs: discountData?.discount_name_rs || "",
      discountPercentage: discountData?.discount_percentage || "",
      discount_description_en: discountData?.description_en || "",
      discount_description_ar: discountData?.description_ar || "",
      discount_description_rs: discountData?.description_rs || "",
      startDate: discountData?.start_date || "",
      endDate: discountData?.end_date || "",
    },
    validationSchema: Yup.object({
      discount_name_en: Yup.string().required(t.error.required),
      discount_name_ar: Yup.string().required(t.error.required),
      discount_name_rs: Yup.string().required(t.error.required),
      discountPercentage: Yup.number().required(t.error.required),
      startDate: Yup.string().required(t.error.required),
      endDate: Yup.string().required(t.error.required),

      discount_description_en: Yup.string().required(t.error.required),
      discount_description_ar: Yup.string().required(t.error.required),
      discount_description_rs: Yup.string().required(t.error.required),
    }),
    onSubmit: async (values) => {
      if (!profilePicture && values.createBanner) {
        errorToast(t.main.uploadBanner);
        return;
      }

      if (!selectedCategory) {
        return;
      }

      const body: any = {
        discount_name_ar: values.discount_name_ar || "",
        discount_name_en: values.discount_name_en || "",
        discount_name_rs: values.discount_name_rs || "",
        discount_percentage: values.discountPercentage,
        description_ar: values.discount_description_ar || "",
        description_en: values.discount_description_en,
        description_rs: values.discount_description_rs,
        start_date: moment(values.startDate, "YYYY-MM-DD")
          .startOf("day")
          .format("YYYY-MM-DDTHH:mm:ss[Z]"),
        end_date: moment(values.endDate, "YYYY-MM-DD")
          .startOf("day")
          .format("YYYY-MM-DDTHH:mm:ss[Z]"),

        category: Number(selectedCategory),
        is_banner: false,
      };
      console.log(body);
      try {
        const encryptedBody = generateEncryptedKeyBody(body) as any;

        if (id) {
          const response = await updateBanner({
            id: id,
            body: encryptedBody,
          }).unwrap();
          if (response.status === 200) {
            successToast(t.main.discountUpdated);
            navigate("/manage-discount");
          } else {
            errorToast(response.message);
          }
        } else {
          const response = await addDiscount(encryptedBody).unwrap();
          if (response.status === 200) {
            successToast(t.main.discountAdded);
            navigate("/manage-discount");
          } else {
            errorToast(response.message);
          }
        }
      } catch (e: any) {
        errorToast(e?.data?.message);
      }
    },
  });

  const getCategoryDetail = async () => {
    try {
      const res = await getCategory({}).unwrap();
      if (res?.status === 200) {
        setCategoryData(res?.data);
      }
    } catch (error: any) {
      console.log(error, "errror");
      errorToast(error?.data?.message || "");
    }
  };

  const handleImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    var files = event.target.files;
    var file = files?.length ? files[0] : null;

    if (!file) {
      setProfilePicture("");
      setImageError("Image is required");
      return;
    }

    if (!file.type.includes("image")) {
      errorToast("Only images are allowed");
      return;
    }

    const image = new Image();
    const objectUrl = URL.createObjectURL(file);

    image.onload = async () => {
      URL.revokeObjectURL(objectUrl);

      const width = image.width;
      const height = image.height;

      if (width < 498 || height < 500) {
        errorToast(t.error.minBanner);
        file = null;
        return;
      }

      try {
        const res = await UploadMedia(file);
        if (res?.status === 200) {
          file = null;
          const imageUrl = res?.data[0]?.media_url;
          setProfilePicture(imageUrl);
          setImageId(res?.data[0]?.id);
          setImageError("");
          successToast("Image uploaded successfully.");
        } else {
          errorToast(res?.message);
        }
      } catch (error) {
        errorToast("Error uploading image. Please try again.");
      }
    };

    image.onerror = () => {
      errorToast("Invalid image file");
    };

    image.src = objectUrl;
  };

  const getDiscountDetail = async () => {
    try {
      const res = await getDiscountDetails({ id: id }).unwrap();
      if (res?.status === 200) {
        setDiscountData(res?.data);

        setSelectedCategory(res?.data?.category?.id);
        setSelectedBannerType(res?.data?.banner_type);
      }
    } catch (error: any) {
      console.log(error, "errror");
      errorToast(error?.data?.message || "");
    }
  };

  useEffect(() => {
    if (id && id !== "add") {
      getDiscountDetail();
    }
  }, []);

  useEffect(() => {
    getCategoryDetail();
  }, []);

  return (
    <div>
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">
            {id ? t.main.editDiscount : t.main.addDiscount}
          </h1>
          <Button
            className="btn btn_primary"
            onClick={() => navigate("/manage-discount")}
          >
            {t.main.back}
          </Button>
        </div>
        <Card className="cards">
          <form onSubmit={formik.handleSubmit}>
            <CardContent sx={{ p: 1 }}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography className="custom_label">
                    {t.main.discountNameEn}
                  </Typography>
                  <TextField
                    name="discount_name_en"
                    id="discount_name_en"
                    fullWidth
                    value={formik.values.discount_name_en}
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    error={
                      formik.touched.discount_name_en &&
                      Boolean(formik.errors.discount_name_en)
                    }
                    helperText={
                      formik.touched.discount_name_en &&
                      formik.errors.discount_name_en
                    }
                  />
                </Grid>

                <Grid item xs={6}>
                  <Typography className="custom_label">
                    {t.main.discountNameAr}
                  </Typography>
                  <TextField
                    name="discount_name_ar"
                    id="discount_name_ar"
                    fullWidth
                    value={formik.values.discount_name_ar}
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    error={
                      formik.touched.discount_name_ar &&
                      Boolean(formik.errors.discount_name_ar)
                    }
                    helperText={
                      formik.touched.discount_name_ar &&
                      formik.errors.discount_name_ar
                    }
                  />
                </Grid>

                <Grid item xs={6}>
                  <Typography className="custom_label">
                    {t.main.discountNameRu}
                  </Typography>
                  <TextField
                    name="discount_name_rs"
                    id="discount_name_rs"
                    fullWidth
                    value={formik.values.discount_name_rs}
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    error={
                      formik.touched.discount_name_rs &&
                      Boolean(formik.errors.discount_name_rs)
                    }
                    helperText={
                      formik.touched.discount_name_rs &&
                      formik.errors.discount_name_rs
                    }
                  />
                </Grid>
                <Grid item xs={6}>
                  <Typography className="custom_label">
                    {t.main.discountPercentage}
                  </Typography>
                  <TextField
                    name="discountPercentage"
                    type="text"
                    fullWidth
                    inputProps={{ maxLength: 3 }}
                    value={formik.values.discountPercentage}
                    // onChange={(val: any) => {
                    //   if (
                    //     val.target.value === " " ||
                    //     val.target.value === "." ||
                    //     val.target.value === "0"
                    //   ) {
                    //   } else if (isNumber(val.target.value)) {
                    //     formik.handleChange(val);
                    //   }
                    // }}
                    onChange={(val) => {
                      const value = val.target.value;
                      if (value === " " || value === ".") return;

                      // Regex to allow only numbers with up to two decimal places
                      if (/^\d*\.?\d{0,2}$/.test(value)) {
                        formik.handleChange(val);
                      }
                    }}
                    error={
                      formik.touched.discountPercentage &&
                      Boolean(formik.errors.discountPercentage)
                    }
                    helperText={
                      formik.touched.discountPercentage &&
                      formik.errors.discountPercentage
                    }
                  />
                </Grid>

                <Grid item xs={6}>
                  <Typography className="custom_label">
                    {t.main.descEng}
                  </Typography>
                  <TextField
                    name="discount_description_en"
                    id="discount_description_en"
                    fullWidth
                    value={formik.values.discount_description_en}
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    error={
                      formik.touched.discount_description_en &&
                      Boolean(formik.errors.discount_description_en)
                    }
                    helperText={
                      formik.touched.discount_description_en &&
                      formik.errors.discount_description_en
                    }
                  />
                </Grid>
                <Grid item xs={6}>
                  <Typography className="custom_label">
                    {t.main.descAr}
                  </Typography>
                  <TextField
                    name="discount_description_ar"
                    id="discount_description_ar"
                    fullWidth
                    value={formik.values.discount_description_ar}
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    error={
                      formik.touched.discount_description_ar &&
                      Boolean(formik.errors.discount_description_ar)
                    }
                    helperText={
                      formik.touched.discount_description_ar &&
                      formik.errors.discount_description_ar
                    }
                  />
                </Grid>

                <Grid item xs={6}>
                  <Typography className="custom_label">
                    {t.main.descRu}
                  </Typography>
                  <TextField
                    name="discount_description_rs"
                    id="discount_description_rs"
                    fullWidth
                    value={formik.values.discount_description_rs}
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    error={
                      formik.touched.discount_description_rs &&
                      Boolean(formik.errors.discount_description_rs)
                    }
                    helperText={
                      formik.touched.discount_description_rs &&
                      formik.errors.discount_description_rs
                    }
                  />
                </Grid>
                <Grid item xs={6}>
                  <Typography className="custom_label">
                    {t.main.startDate}
                  </Typography>
                  <TextField
                    name="startDate"
                    type="date"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    value={formik.values.startDate}
                    inputProps={{
                      min: new Date().toISOString().split("T")[0],
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      const year = value.split("-")[0]; // Extract year
                      if (year.length > 4) return; // Prevent input if year exceeds 4 digits
                      formik.handleChange(e); // Update Formik state
                    }}
                    error={
                      formik.touched.startDate &&
                      Boolean(formik.errors.startDate)
                    }
                    helperText={
                      formik.touched.startDate && formik.errors.startDate
                    }
                  />
                </Grid>

                <Grid item xs={6}>
                  <Typography className="custom_label">
                    {t.main.endDate}
                  </Typography>
                  <TextField
                    name="endDate"
                    type="date"
                    fullWidth
                    disabled={!formik.values.startDate}
                    InputLabelProps={{ shrink: true }}
                    value={formik.values.endDate}
                    inputProps={{
                      min: formik.values.startDate
                        ? new Date(
                            new Date(formik.values.startDate).getTime() +
                              24 * 60 * 60 * 1000
                          )
                            .toISOString()
                            .split("T")[0]
                        : new Date().toISOString().split("T")[0], // Default to today's date if startDate is not selected
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      const year = value.split("-")[0]; // Extract year
                      if (year.length > 4) return; // Prevent input if year exceeds 4 digits
                      formik.handleChange(e); // Update Formik state
                    }}
                    error={
                      formik.touched.endDate && Boolean(formik.errors.endDate)
                    }
                    helperText={formik.touched.endDate && formik.errors.endDate}
                  />
                </Grid>

                <Grid item lg={6} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">
                    {t.main.category}
                  </Typography>
                  <FormControl sx={{ width: "100%" }}>
                    <Select
                      className="select_div"
                      fullWidth
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      // value={priceType}
                      value={selectedCategory}
                      inputProps={{
                        "aria-label": "Without label",
                      }}
                      displayEmpty
                      onChange={handlePricingChange}
                      error={error && !selectedCategory}
                    >
                      <MenuItem value="" disabled>
                        {t.main.selectCategory}
                      </MenuItem>
                      {categoryData?.length
                        ? categoryData?.map((item: any) => (
                            <MenuItem key={item?.id} value={item?.id}>
                              {item?.category_name || ""}
                            </MenuItem>
                          ))
                        : null}
                    </Select>
                    {error && !selectedCategory ? (
                      <h6 className="err_msg">{t.error.required}</h6>
                    ) : (
                      ""
                    )}
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    onClick={() => setError(true)}
                  >
                    {id ? t.main.updateDiscount : t.main.addDiscount}
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </form>
        </Card>
      </div>
    </div>
  );
};

export default AddDiscount;
